const isALowerProxyBiddingAmountEnabled = ['yes', 'true'].includes(process.env.NEXT_PUBLIC_ENABLE_LOWER_PROXY_BID_INCREMENT_AMOUNT);

const BID_STATES = Object.freeze({
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
});

const BID_TYPES = Object.freeze({
  PROXY: 'proxy',
  OFFER: 'offer',
});

const PROXY_BID_INCREMENT = isALowerProxyBiddingAmountEnabled ? 1 : 50;

const BANK_HOLIDAY_DIVISIONS = Object.freeze({
  ENGLAND_AND_WALES: 'england-and-wales',
});

module.exports = {
  BID_STATES,
  BID_TYPES,
  PROXY_BID_INCREMENT,
  BANK_HOLIDAY_DIVISIONS,
};
